import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom"
import Spinner from '../../../elements/Spinner'
import Card from "../../../elements/Card";
import { CategoryNumToName } from "./CategoryNumToName";
import { Game, GetClientListservertypesByCategory } from "../../../../api/api.gen";
import { capitalizeWords, getCurrencyTranslated } from "../../../../utils/util";
import useGlobalState from "@/state";

const GameSelection = () => {
    let { cat } = useParams();
    const [data, setData] = useState<Game[]>();
    const [ loading, setLoading ] = useState(false);
    const selectedCurrency = useGlobalState(state => state.selectedCurrency)

    const onRender = (cat : string) => {
        document.title = capitalizeWords(cat.replaceAll("-", " ")) + " Hosting - SNHCloud.com"
        setLoading(true)
        let catno: string = "1"
        let CatNumToNameArray = Object.keys(CategoryNumToName)
        for (let index = 0; index < CatNumToNameArray.length; index++) {
            const cn = CatNumToNameArray[index];
            if (CategoryNumToName[cn] == cat) {
                catno = cn
            }
        }
        GetClientListservertypesByCategory(Number(catno))
        .then(response => {
            setData(response)
        })
        .then(() => setLoading(false));
    }
    
    useEffect(() => {
        const oldTile = document.title
        onRender(cat);
        return () => {
            document.title = oldTile
        }
    }, []);

    return(
        <>
        {loading &&
            <Spinner />
        }
        <h1 className="text-center pt-2">{capitalizeWords(cat.replaceAll("-", " "))} Hosting</h1>
        <div className="grid center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:px-20 my-8">
            {data?.map(ele => (
                <Link key={ele.Name} to={`/hosting/${cat}/${ele.Name}`}>
                    <Card name={ele.Label} banner={ele.Name} extra={-2} subtitle={`Starting from ${getCurrencyTranslated(ele.StartsFromCredits, selectedCurrency)}`}/>
                </Link>
            ))}
        </div>	
        <div className="text-2xl text-center">
            Contact us via a Discord Ticket in case the game your looking for is not above 
        </div>
        </>
    )
}

export default GameSelection;